/* eslint-disable no-console */
export const error = (...attrs) => console.error('[TRAQ]', ...attrs);
export const warn = (...attrs) => console.warn('[TRAQ]', ...attrs);
export const log = (...attrs) => console.log('[TRAQ]', ...attrs);
/* eslint-enable no-console */
